export const calcUmbrellaIndex = (pop) => {
  if (pop >= 90) return 4
  if (pop >= 70) return 3
  if (pop >= 20) return 2
  return 1
}
